import { createClient } from '@supabase/supabase-js'
const supabaseUrl = process.env.VUE_APP_SUPABASE_URL
const supabaseKey = process.env.VUE_APP_SUPABASE_KEY
export const supabase = createClient(supabaseUrl, supabaseKey )

export function query(table) {
    return supabase
        .from(table)
        .select('*', { count: 'exact' })
}

export function upsert(table, arr) {
    return supabase
        .from(table)
        .upsert(arr, { onConflict: ['id'] })
        .select()
}

export function del(table, arr) {
    return supabase
        .from(table)
        .delete()
        .in('id', arr);
}

export function insert(table, arr) {
    return supabase
        .from(table)
        .insert(arr)
        .select()
}

export  function rpc(fun_mane, args) {
    return  supabase.rpc(fun_mane, args
    )
}

const name = process.env.VUE_APP_SUPABASE_NAME
export async function uploadUrl( Path, File) {
    const { data, error } = await supabase.storage
        .from(name) // 替换为你的存储桶名称
        .upload(Path, File);
    const publicURL = supabase.storage
        .from(name)
        .getPublicUrl(`${data.path}`);
    return publicURL.data.publicUrl
}

